import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#0DD9E3"
        d="M5 10.285H2.75a.752.752 0 01-.75-.75c0-.412.337-.75.75-.75H5c.412 0 .75.338.75.75 0 .413-.338.75-.75.75zM6.317 7.101a.753.753 0 01-.53-.22l-1.59-1.589a.753.753 0 010-1.06.753.753 0 011.06 0l1.59 1.59a.744.744 0 010 1.059.745.745 0 01-.53.22zM9.502 5.782a.752.752 0 01-.75-.75v-2.25c0-.413.338-.75.75-.75.413 0 .75.337.75.75v2.25c0 .412-.337.75-.75.75zM12.683 7.101a.752.752 0 01-.75-.75c0-.197.08-.389.22-.53l1.589-1.588a.753.753 0 011.06 0c.29.29.29.768 0 1.059l-1.59 1.59a.753.753 0 01-.53.22zM4.728 15.052a.752.752 0 01-.75-.75c0-.197.08-.389.22-.53l1.59-1.589a.753.753 0 011.059 0c.29.29.29.77 0 1.06l-1.59 1.589a.753.753 0 01-.529.22zM11.479 8.36a2.232 2.232 0 00-3.15-.033 2.232 2.232 0 00-.033 3.15l.033.033 1.851 1.851a.376.376 0 00.53 0l2.62-2.62a.376.376 0 000-.53L11.48 8.36zM21.921 18.805l-7.003-7.003a.376.376 0 00-.53 0l-2.62 2.62a.376.376 0 000 .53l7.003 7.004c.863.876 2.274.89 3.15.032.877-.862.89-2.273.033-3.15-.01-.01-.019-.023-.033-.033z"
      ></path>
    </svg>
  );
}

export default Icon;
